import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
<table>
<thead parentName="table">
<tr parentName="thead">
<th parentName="tr" {...{
            "align": "center"
          }}>{`Prefix`}</th>
<th parentName="tr" {...{
            "align": "left"
          }}>{`Method`}</th>
</tr>
</thead>
<tbody parentName="table">
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`clg→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.log(object)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`clo→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.log("object", object)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`ctm→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.time("timeId")`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cte→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.timeEnd("timeId")`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cas→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.assert(expression,object)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`ccl→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.clear()`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cco→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.count(label)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cdi→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.dir`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cer→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.error(object)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cgr→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.group(label)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cge→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.groupEnd()`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`ctr→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.trace(object)`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cwa→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.warn`}</inlineCode></td>
</tr>
<tr parentName="tbody">
<td parentName="tr" {...{
            "align": "center"
          }}><inlineCode parentName="td">{`cin→`}</inlineCode></td>
<td parentName="tr" {...{
            "align": "left"
          }}><inlineCode parentName="td">{`console.info`}</inlineCode></td>
</tr>
</tbody>
</table>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      